// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button_btn__pbjW0","white":"Button_white__0M8_I","transparent":"Button_transparent__tpDga"};